import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { CREATE_SURGE_COMPAIGN, CREATE_SURGE_COMPAIGN_SUCCESS, CREATE_SURGE_COMPAIGN_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createSurgeCompaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`Campaign created successfully.`);
      yield put({
        type: CREATE_SURGE_COMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to create campaign.`;
      cogoToast.error(message);
      yield put({
        type: CREATE_SURGE_COMPAIGN_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to create campaign.`);
    yield put({ type: CREATE_SURGE_COMPAIGN_ERROR, payload: error });
  }
}

export function* watchcreateSurgeCompaign() {
  yield takeEvery(CREATE_SURGE_COMPAIGN, createSurgeCompaign);
}

function* createSurgeCompaignSaga() {
  yield all([fork(watchcreateSurgeCompaign)]);
}

export default createSurgeCompaignSaga;
